export default __webpack_public_path__ + "static/media/ag-dropdown.6b893826.webp";